import { useParams } from 'react-router-dom';

export function useLang(defaultLanguage = 'en') {
    const { lang } = useParams();

    const language = lang || defaultLanguage;

    const urlLanguage = (path) => `/${ language }${ path }`;

    return { language, urlLanguage };
};